import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import {
  TargetingScope,
  getScope
} from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { SettingsSummaryView } from './settings-summary';
import { EditCampaignSettingsView } from './edit-campaign';
import { EditAdGroupSettingsView } from './edit-adgroup';
import Template from './all-settings.pug';

export class AllSettingsView extends DeterministicView {
  initialize({
    campaignId,
    adgroupId,
    dataSource,
    perfMarker,
    ccJsData,
    serverContext,
    scopeServiceScope,
    deps = {},
  }) {
    const scope = getScope(campaignId, adgroupId);
    super.setState(_.extend({}, {
      campaignId,
      adgroupId,
      scope,
      dataSource,
      serverContext,
      scopeServiceScope,
    }));

    this.perfMarker = perfMarker;
    this.ccJsData = ccJsData;
    this.deps = deps;
    this.model.on('change', model => this.onModelChange(model));
    this.onModelChange(this.model);
  }

  /**
   * Class name of the root element
   * @type {string}
   * @override
   */
  get className() { return 'all-settings-view'; }

  /**
   * Template of the AllSettingsView
   * @type {TemplateCallback}
   * @override
   */
  get template() { return Template; }

  /**
   * Update the inner `PillControl`
   * @param {Object} state - The new config of the `PillControl`
   * @returns {PillControlWrapperView} - The view itself
   */
  setState({
    campaignId,
    adgroupId,
  }) {
    super.setState({
      campaignId,
      adgroupId,
      scope: getScope(campaignId, adgroupId),
    });
  }

  onModelChange(model) {
    const scope = model.get('scope');
    const campaignId = model.get('campaignId');
    const adgroupId = model.get('adgroupId');
    const dataSource = model.get('dataSource');
    const serverContext = model.get('serverContext');
    const scopeServiceScope = model.get('scopeServiceScope');
    const { perfMarker, ccJsData, deps } = this;

    const SettingsViewWrapper = class extends DeterministicWrapperView {
      viewFactory() {
        let view;

        switch (scope) {
          case TargetingScope.Account:
            view = new SettingsSummaryView({
              dataSource,
              perfMarker,
              deps,
            });
            break;

          case TargetingScope.Campaign:
            view = new EditCampaignSettingsView({
              campaignId,
              perfMarker,
              ccJsData,
              deps,
              serverContext,
              scopeServiceScope,
            });
            break;

          case TargetingScope.AdGroup:
            view = new EditAdGroupSettingsView({
              campaignId,
              adgroupId,
              perfMarker,
              deps,
            });
            break;

          default:
            throw new Error('Unexpected targeting settings scope!');
        }
        return view;
      }
    };

    this.setChild('all-settings-container', new SettingsViewWrapper());
  }
}
